import { defaultSettings } from '@/constants/optima';

const state = {
  indentCount: 0,
  isLoading: false,
  reOptimize: false,
  holdConisgnees: [],
  isUpdating: false,
  isPaginating: false,
  hasEmpty: false,
  deliveryNosHasEmpty: false,
  indents: [],
  summaryConsignees: [],
  summaryDeliveryNos: [],
  notCombineConisgnee: [],
  holdConsigneesWithDelivery: [],
  vehicles: [],
  depotDeliveryList: [],
  uploadDetails: {},
  defaultDepot: {
    depot_id: null,
    movement: 1,
  },
  not_combines: [],
  settings: defaultSettings,
  materials: [],
  editIndentIds: [],
  editIndents: [],
  indentDetails: {},
  filter: {
    page: 1,
    query: null,
    transporter_id: null,
  },
  detailsPage: 1,
  indent: [],
  consigneeMaterials: [],
  isOptimaLoading: false,
  isOptimaUpdating: false,
  isOptimaOrderLoading: false,
  all: [],
  totals: {},
  orderDetails: {},
  compareList: [],
  xls_materials: {},
  deliveryPickList: {
    status: 1,
    startDate: null,
    endDate: null,
    delivery_number: null,
    page: 1,
  },
  depotWiseDeliveryNos: [],
  deliveryPicklistMeta: {},
  deliveryProcessedCounts: {
    processed: 0,
    rejected: 0,
  },
  setInvalidPath: '',
  optimaAutoRun: {},
  indentBucket: [],
  movement_list: [
    { id: 1, label: 'Secondary' },
    { id: 2, label: 'Primary' },
  ],
  optimaRejectionsListData: [],
  gatesMap: {},
  selectedIndentMap: {},
  indentIdWiseData: {},
  selectAll: false,
  delivery_state_split_list: [
    { id: 1, label: 'Pack in Progress' },
    { id: 2, label: 'Pack Complete' },
  ],
  optimaAutoIndent: {},
  optimaCurrentJobId: null,
  optimaCurrentPage: 'order_listing',
  deliveryPicklist: [],
  selectedPicklistMap: {},
  picklistIdsMap: {},
  selectAllPicklistConsignees: false,
  deliveryIndentsPickList: [],
  showIndentTopupDrawer: false,
  splitObject: {},
  returnContracts: [],
  splitOrderSelectedIndex: '',
  combineObject: {},
  combineOrderSelectedIndex: '',
  combineAndSplitBtnDisable: {},
  contractCollection: [],
  selectedDeliveryNumber:{},
  selectedPickListData: {},
  selectedPicklistIds: [],
  selectedDeliveryDetails: {},
  selectedIndentIds: [],
  selectedIndentData: {},
  selectedIndentMap: {},
  picklistAggregateTotals: null,
  indentAggregateTotals: null,
};
export default state;
